import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { COLORS } from '@enums/colors'

export const NavLink = styled(Link)`
  position: relative;
  top: -2px;
  text-decoration: none;
  font-family: 'Open Sans', sans-serif;
  font-size: 0.875rem;
  font-weight: 500;
  color: ${COLORS.teal};
`
